import { memo, ReactElement } from 'react';
import { UserPopulatedDTO } from '../../api/generated';
import { TrainRecordings } from './TrainRecordings';
import { TruckRecordings } from './TruckRecordings';

export interface RecordingsPageProps {
  user: UserPopulatedDTO;
}

export const RecordingsPage = memo(function ({ user }: RecordingsPageProps): ReactElement {
  const preferredJobsite = user.preferredJobsite;

  if (preferredJobsite?.type === 'train') return <TrainRecordings user={user} />;

  return <TruckRecordings user={user} />;
});
